import { lazy, Suspense } from 'react';
import DefaultLayout from '@/layouts/DefaultLayout';
import HomeLayout from '@/layouts/HomeLayout';
import LandingRouter from '@/routes/LandingRouter';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

// 라우트 단위 코드 스플리팅: 페이지 컴포넌트는 진입 시 동적 로드한다.
const Company = lazy(() => import('@/views/company/Company'));
const HomeIndex = lazy(() => import('@/views/home'));
const AiHomeIndex = lazy(() => import('@/views/ai-home'));
const MainIndex = lazy(() => import('@/views/main'));
const TemplateIndex = lazy(() => import('@/views/template').then((m) => ({ default: m.TemplateIndex })));
const History = lazy(() => import('@/views/history/History'));
const Patent = lazy(() => import('@/views/patent/Patent'));
const DataInfuser = lazy(() => import('@/views/product/DataInfuser'));
const AiInfuser = lazy(() => import('@/views/product/AiInfuser'));
const QufaStudio = lazy(() => import('@/views/product/QufaStudio'));
const VoiceDesk = lazy(() => import('@/views/product/VoiceDesk'));
const DataMapMain = lazy(() => import('@/views/product/datamap/DataMapMain'));

const Routes = () => {
  // Routes
  const routes = [
    {
      element: <DefaultLayout />,
      children: [
        {
          path: '/patents',
          element: <Patent />,
        },
        {
          path: '/histories',
          element: <History />,
        },
        {
          path: '/products/infuser',
          element: <DataInfuser />,
        },
        {
          path: '/products/ai-infuser',
          element: <AiInfuser />,
        },
        {
          path: '/products/datamap',
          element: <DataMapMain />,
        },
        {
          path: '/aboutus',
          element: <Company />,
        },
        {
          path: '/products/qufa-studio',
          element: <QufaStudio />,
        },
        {
          path: '/products/voicedesk',
          element: <VoiceDesk />,
        },
      ],
    },
  ];

  const homeRoutes = [
    {
      element: <HomeLayout />,
      children: [
        {
          // 설정파일(site-config.json)에 따라 공공데이터/AI 랜딩을 선택 렌더
          path: '/',
          element: <LandingRouter />,
        },
        {
          // 공공데이터 메인 고정 진입점 (직접 링크 공유용)
          path: '/data',
          element: <HomeIndex />,
        },
        {
          // AI 랜딩 고정 진입점 (직접 링크 공유용)
          path: '/ai',
          element: <AiHomeIndex />,
        },
        {
          path: '/template',
          element: <TemplateIndex />,
        },
      ],
    },
  ];

  // 통합 메인 직접 진입점 (레이아웃 없이 풀블리드, 검토/직접 링크용).
  // 루트(/) 노출은 site-config.json 의 defaultLanding='main' 일 때만.
  const previewRoutes = [
    {
      path: '/main',
      element: <MainIndex />,
    },
  ];

  // Combine and conditionally include routes based on authentication status
  const router = createBrowserRouter([...routes, ...homeRoutes, ...previewRoutes]);

  // Provide the router configuration using RouterProvider
  return (
    <Suspense fallback={null}>
      <RouterProvider router={router} />
    </Suspense>
  );
};

export default Routes;
